import { render } from "./BrandSelect.vue?vue&type=template&id=8f098806&scoped=true"
import script from "./BrandSelect.vue?vue&type=script&lang=js"
export * from "./BrandSelect.vue?vue&type=script&lang=js"

import "./BrandSelect.vue?vue&type=style&index=0&id=8f098806&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f098806"]])

export default __exports__